import { Component, OnInit } from '@angular/core';
import { ScheduleReportService } from '../schedule-report.service';
import { BehaviorSubject, Observable, Subject, delay, map, merge, of, startWith, switchMap, takeUntil, tap } from 'rxjs';
import { FormArray, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { untilDestroyed } from '@ngneat/until-destroy';
// import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

@Component({
  selector: 'lib-recipients',
  templateUrl: './recipients.component.html',
  styleUrls: ['./recipients.component.scss']
})
export class RecipientsComponent implements OnInit {

  _onDestroy: Subject<void> = new Subject();
  recipient$: BehaviorSubject<any> = new BehaviorSubject(null);
  rnameFiltered$: Observable<string[]>[] = [];
  remailFiltered$: Observable<string[]>[] = [];

  recipientsFull: any[];
  recipientArray: FormArray;
  inputRequired: boolean;
  duplicates: any = [];

  constructor(
    public scheduleReport: ScheduleReportService,
  ) { }

  ngOnInit(): void {
    this.recipientArray = this.scheduleReport.scheduleForm.get("recipients") as FormArray;

    // setTimeout(() => {
    //   this.checkDuplicates('recipient_email')
    // });

    this.scheduleReport.refresh$.pipe(
      delay(10),
      startWith(true),
      switchMap(_ => this.scheduleReport.loadRecipients()),
      untilDestroyed(this),
      takeUntil(this.scheduleReport.reset$),
    ).subscribe((list: any) => {
      this.recipient$.next(list);
      this.addRecipient();
    });


  }

  manageFormArrayValues(index: number) {
    merge(
      // this.recipientArray.valueChanges,
      this.recipientArray.at(index).get('recipient_name').valueChanges
    ).pipe(
      startWith(''),
      takeUntil(this._onDestroy),
    ).subscribe(value => {
      value = value?.toLowerCase().trim();

      this.rnameFiltered$[index] = this.filterRecipients("name").pipe(
        map(val => val?.filter(s => s?.toLowerCase().includes(value))),
      )
    });

    merge(
      // this.recipientArray.valueChanges,
      this.recipientArray.at(index).get('recipient_email').valueChanges,
      // this.scheduleReport.refresh$
    ).pipe(
      startWith(''),
      takeUntil(this._onDestroy),
    ).subscribe(value => {
      value = value?.toLowerCase().trim();

      this.remailFiltered$[index] = this.filterRecipients("email").pipe(
        map(val => val?.filter(s => s?.toLowerCase().includes(value))),
      )
      this.checkDuplicates('recipient_email');
    });
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  recipientRequired(index: number): Boolean {
    this.inputRequired = index == 0 || (index > 0 && this.recipientArray.at(index).get('recipient_name').value) ? true : false;
    return this.inputRequired;
  }

  addRecipient(index?: number) {
    if (!this.recipientArray.length) {
      this.recipientArray.push(this.newRecipient());
    }
    const value = (this.recipientArray.value[this.recipientArray.length - 1]);
    if (value.recipient_name != "" || value.recipient_email != "") {
      this.recipientArray.push(this.newRecipient());
    }
    this.manageFormArrayValues(this.recipientArray.length - 1);

    if (index != null && this.recipientArray.at(index).get('recipient_email').value && !this.recipientArray.at(index).get('recipient_name').dirty) {
      this.recipientsFull.find((o, i) => {
        if (o.email == this.recipientArray.at(index).get('recipient_email').value) {
          this.recipientArray.at(index).get('recipient_name').setValue(this.recipientsFull[i].name)
        }
      })
    }

  }


  newRecipient(): FormGroup {
    return new FormGroup({
      recipient_name: new FormControl(''),
      recipient_email: new FormControl('',[Validators.pattern("^[^\\s@()]+@[a-zA-Z0-9.-]+?\\.[^\\s@]{1,}$")])
    })
  }

  checkDuplicates(key_form) {
    for (const index of this.duplicates) {
      let errors = this.recipientArray.at(index).get(key_form).errors as Object || {};
      delete errors['duplicated'];
      this.recipientArray.at(index).get(key_form).setErrors(Object.keys(errors as ValidationErrors)?.length ? (errors as ValidationErrors) : null);
    }
    this.duplicates = [];

    let dict = {};
    this.recipientArray.value.forEach((item, index) => {
      dict[item.recipient_email] = dict[item.recipient_email] || [];
      dict[item.recipient_email].push(index);
    });
    for (var key in dict) {
      if (dict[key].length > 1 && key!="")
        this.duplicates = this.duplicates.concat(dict[key]);
    }
    for (const index of this.duplicates) {
      this.recipientArray.at(index).get(key_form).markAsTouched();
      this.recipientArray.at(index).get(key_form).setErrors({ duplicated: true });
    }
  }

  removeRec(id: number): void {
    this.recipientArray.removeAt(id);
    this.checkDuplicates('recipient_email');
  }

  filterRecipients(key: any): Observable<any> {
    let ret;
    this.recipient$.pipe(
      tap(x => this.recipientsFull = x),
      map(rec => rec.map((x => key == "name" ? x.name : x.email))),
      map(rec => rec.filter((x, i) => key == "name" ? x != null && rec.indexOf(x) === i : x != null && rec.indexOf(x) === i && x.match(/^[^\s@()]+@[a-zA-Z0-9.-]+?\.[^\s@]{1,}$/))),
    ).subscribe(value => {
      ret = value;

    })

    return of(ret);
  }

}
